import React, { useEffect, useRef, useState } from 'react';
const SCRIPT_SRC = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
declare global {
  interface Window {
    checkoutElements?: {
      init: (element: string) => {
        mount: (selector: string) => void;
      };
    };
  }
}

/**
 * Renders Hotmart's Sales Funnel widget (the official SÍ / NO one-click
 * buttons). The widget only works when the visitor arrives from the Hotmart
 * checkout, so a fallback message is shown while it boots.
 */
export function HotmartSalesFunnel() {
  const mountedRef = useRef(false);
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');
  useEffect(() => {
    const mountWidget = () => {
      if (mountedRef.current) return;
      if (!window.checkoutElements) {
        setStatus('error');
        return;
      }
      mountedRef.current = true;
      try {
        window.checkoutElements.init('salesFunnel').mount('#hotmart-sales-funnel');
        setStatus('ready');
      } catch {
        setStatus('error');
      }
    };
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${SCRIPT_SRC}"]`);
    if (window.checkoutElements) {
      mountWidget();
      return;
    }
    if (existing) {
      existing.addEventListener('load', mountWidget);
      existing.addEventListener('error', () => setStatus('error'));
      return () => existing.removeEventListener('load', mountWidget);
    }
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.addEventListener('load', mountWidget);
    script.addEventListener('error', () => setStatus('error'));
    document.body.appendChild(script);
  }, []);
  return <div className="w-full" data-id="element-110" data-mp="5xbfv0l524ip">
      <div id="hotmart-sales-funnel" className="w-full" data-id="element-111" data-mp="5y4cv9uapfnn" />

      {status !== 'ready' && <p className="text-center text-sm text-warmgray" role="status" aria-live="polite" data-id="element-112" data-mp="24auzmh8if2lm">
          {status === 'loading' ? 'Cargando tus opciones de compra…' : 'No pudimos cargar el botón de compra. Recarga la página o vuelve a abrir el enlace que recibiste después de tu compra.'}
        </p>}
    </div>;
}